import "../../../assets/scss/components/tnc.scss";
import React, { useState, useContext, useEffect } from "react";
import Tnc from "../../../components/CommonCompnents/Tnc";
import { SubmitTnc } from "../../../services/login/loginApiService";
import LoginService from "../../../services/login/loginService";
import { MyAuthContext } from "../../../Context/AuthContext";
import LoginErrMsg from "../../../components/login/generic/loginErrMsg";
import { accRedircet } from "../../../services/genralServise";
import { config } from "../../../config/domain";
import { RoutesUrl } from "../../Routes/constents";

const TncPage = (props) => {
  let [userId, setUserId] = useState();
  const [tncStatus, setTncStatus] = useState(false);
  const [isError, setIsError] = useState(false);
  const isAuthContext = useContext(MyAuthContext);
  const [apiError, setApiError] = useState("");

  const updateTncStatus = () => {
    setTncStatus(!tncStatus);
  };

  const postTncStatusRes = async (res) => {
    if (res && res.data && res.data.sts) {
      localStorage.setItem("tncAccepted", "true");
      accRedircet(config.root + RoutesUrl.MyApps);
      isAuthContext.isAuthFunction(true, true);
    } else if (res && res.error) {
      setApiError(res.error.errMsg)
    }
  };

  const postTncStatus = () => {
    if (!tncStatus) {
      setIsError(true);
    } else {
      let body = {
        cnsntNm: "APIConsent",
        sts: tncStatus,
      };
      setApiError("");
      SubmitTnc(postTncStatusRes, userId, body);
    }
  };

  useEffect(async () => {
    let userId = await LoginService.getAccData("userID");
    setUserId(userId);
  }, []);

  return (
    <div>
      <Tnc
        updateTncStatus={updateTncStatus}
        tncStatus={tncStatus}
        postTncStatus={postTncStatus}
      />
      {apiError && (
        <div className="text-center">
          <span>
            <LoginErrMsg className="mg-b40">{apiError}</LoginErrMsg>
          </span>
        </div>         
      )}
    </div>
  );
};

export default TncPage;
